import { IconButton } from '@coolblue-development/freddy';
import { ArrowLeft, ArrowRight } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

import getButtonStyles from './Button.styled';

const Button = ({
  next,
  show,
  onClick,
  smaller = false
}: {
  next?: boolean;
  show?: boolean;
  onClick: () => void;
  smaller?: boolean;
}) => {
  const { t } = useTranslation('webshop');

  return (
    <IconButton
      hideUntil='md'
      shape={{ md: `arch-${next ? 'right' : 'left'}`, lg: 'round' }}
      variant='solid'
      size={smaller ? 'large' : 'xlarge'}
      aria-label={next ? t('ariaLabelNext') : t('ariaLabelPrev')}
      sx={theme => getButtonStyles({ next, show }, theme)}
      onClick={onClick}
    >
      {next ? <ArrowRight /> : <ArrowLeft />}
    </IconButton>
  );
};

export default Button;
